// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".EmptyState__container___2ai06{display:flex;flex-direction:column;align-items:center;margin:0 35%}.EmptyState__emptyStateIcon___1Zqvc{width:40px;height:40px;opacity:0.4;margin-bottom:12px}.EmptyState__closeIcon___1-4zz{transform:rotate(180deg);margin-bottom:24px}.EmptyState__empyStateTitle___1bNM1{text-align:center;font-weight:500}.EmptyState__emptyStateSubtitle___1Kdba{text-align:center;font-size:12px}\n", ""]);
// Exports
exports.locals = {
	"container": "EmptyState__container___2ai06",
	"emptyStateIcon": "EmptyState__emptyStateIcon___1Zqvc",
	"closeIcon": "EmptyState__closeIcon___1-4zz",
	"empyStateTitle": "EmptyState__empyStateTitle___1bNM1",
	"emptyStateSubtitle": "EmptyState__emptyStateSubtitle___1Kdba"
};
module.exports = exports;
